import React from 'react';
import Styled from 'styled-components';

interface TMarkUpProps {
  value: string;
}

const Link = Styled.a`
   text-decoration: underline;`;

const TextMarkup: React.FC<TMarkUpProps> = ({ value }): JSX.Element => {
  return <>{value}</>;
};

const TMarkUp: React.FC<TMarkUpProps> = ({ value }): JSX.Element => {
  const regexPattern = new RegExp(
    '\\(([^\\)]+)\\)\\[(https?:\\/\\/[^\\]]+)]',
    'g'
  );

  const results = value.split(regexPattern);

  const urlsResult = [];
  for (let i = results.length - 1; i >= 0; i -= 1) {
    if (results[i].startsWith('http')) {
      urlsResult.push({
        values: [results[i], results[i - 1]],
        type: 'link',
        id: i,
      });
      i -= 1;
    } else {
      urlsResult.push({
        values: [results[i]],
        type: 'text',
        id: i,
      });
    }
  }
  return (
    <>
      {urlsResult
        .reverse()
        .map((res) =>
          res.type === 'link' ? (
            <Link href={res.values[0]}>{res.values[1]}</Link>
          ) : (
            <TextMarkup key={`t_markup_${res.id}`} value={res.values[0]} />
          )
        )}
    </>
  );
};

export default TMarkUp;
